import { dateTimeFromServer } from '../utils/format'
import { JSON } from '../utils/types'
import { PaymentMethod } from './PaymentMethod'

export default class PayCash extends PaymentMethod {
  readonly barcode: string
  readonly formattedExpirationDate: string
  readonly barcodeBase64Image: string
  readonly sentTo: string
  readonly instructionsLink: string
  readonly auxiliaryUrl: string

  constructor(data: JSON) {
    super(data)
    this.barcode = data.barcode
    this.formattedExpirationDate = dateTimeFromServer(this.expirationDate, false)!
    this.barcodeBase64Image = data.barcode_base64_image
    this.sentTo = data.sent_to
    this.instructionsLink = data.instructions_link
    this.auxiliaryUrl = data.auxiliary_url
  }
}
